import lead from '@modules/lead'
import tracker from '@titanio/tracker'
import Header from '@components/header/header'

const loader = () => {
  setTimeout(() => lead.mount(), 0)
  setTimeout(() => tracker.mount(), 0)
  setTimeout(() => new Header().mount(), 0)
}

export default { loader }
